import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FullStar } from 'assets/images/full_star.svg';
import { ReactComponent as HalfStar } from 'assets/images/half_star.svg';
import { ReactComponent as EmptyStar } from 'assets/images/empty_star.svg';
import { TGame, TReview } from 'types';
import './styles.scss';

interface IRatingReviews {
  game: TGame;
  onlyRating?: boolean;
}

interface IReview {
  review: TReview;
}

const MAX_STARS = 5;

const Review: React.FC<IReview> = ({ review }) => {
  return (
    <div className="mb2">
      <div className="flex items-center mb1">
        <span className="reviewer-logo"></span>
        <span>{review.user}</span>
      </div>
      <div className="review-info">
        {Array.from(Array(MAX_STARS)).map((_, i) => (
          <span key={`r_star_${i}`} className={review.rating > i ? 'filled' : ''}>★</span>
        ))}
        <span className="review-date ml1">{review.date}</span>
      </div>
      <div>{review.content}</div>
    </div>
  );
};

const RatingReviews: React.FC<IRatingReviews> = ({ game, onlyRating = false }) => {
  const { t } = useTranslation();

  return (
    <div className="reviews-container flex flex-col p-side mb2">
      <p className="heading">{t('rating')}</p>
      <div className="ratings flex mb2">
        <div className="rating-score">
          <div>{game.rating.toFixed(1)}</div>
          <div>{`${t('outOf')} 5`}</div>
        </div>
        <div className="flex flex-1 flex-col justify-end items-center">
          <div>
            {Array.from(Array(MAX_STARS)).map((_, i) => (
              <span key={`star_${i}`} className="rating-star">
                {Math.floor(game.rating) >= i + 1 ? <FullStar /> : (
                  <>{(Math.floor(game.rating) === i && game.rating % 1 > 0) ? <HalfStar /> : <EmptyStar />}</>
                )}
              </span>
            ))}
          </div>
          <div className="reviews-count">{game.reviewsCount}&nbsp;{t('ratings')}</div>
        </div>
      </div>
      {!onlyRating && (
        <div className="flex flex-col">
          {game.reviews?.map((review: TReview) => (
            <Review key={review.id} review={review} />
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(RatingReviews);
